/*
  SENTYR SKIN — el-collection.js (page collection, port vanilla de el-collection.js Penrose).
  - tri : le <select class="el-collection-sort"> soumet son formulaire GET (?sort_by=…) ;
  - « voir plus / voir moins » sur mobile (classes el-load-more-js / el-load-less-js, CSS Penrose).
  Les onglets #tab1/#tab2 et le tiroir de tri Penrose ne sont pas utilisés sur la page collection reproduite (collection_all).
*/
(function () {
  'use strict';
  if (window.__elCollectionInit) return;
  window.__elCollectionInit = true;

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (s instanceof Element && s.classList.contains('el-collection-sort') && s.form) s.form.submit();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('.el-load-more-js')) {
      e.preventDefault();
      document.body.classList.add('el-load-all-products');
    } else if (t.closest('.el-load-less-js')) {
      e.preventDefault();
      document.body.classList.remove('el-load-all-products');
    }
  });
})();
